import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-coming',
  templateUrl: './app-coming.component.html',
  styleUrls: ['./app-coming.component.css']
})
export class AppComingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/app-coming/app-coming.component.ts